import {
  OnboardingCompletedResponseModel,
  OnboardingCompletedResponseApiModel,
} from './onboardingCompleted.model';

export const onboardingCompletedAdapter = ({
  data: { data },
}: OnboardingCompletedResponseApiModel): OnboardingCompletedResponseModel =>
  data;
